function noop() {
}
function noopValue(value) {
  return value;
}
export {
  noop,
  noopValue
};
